"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainPdfInvoice = mapToDomainPdfInvoice;
function mapToDomainPdfInvoice(dto) {
    return {
        id: dto.id,
        machine: {
            name: dto.machine.name || null,
        },
        issuer: dto.issuer
            ? {
                legalName: dto.issuer.legalName,
                address: dto.issuer.address,
                taxId: dto.issuer.taxId,
                phone: dto.issuer.phone,
                email: dto.issuer.email,
            }
            : null,
        customer: mapToDomainCustomer(dto.customer),
        createDate: dto.createDate,
        invoiceNumber: dto.invoiceNumber,
        orderItems: dto.orderItems,
        vatDetails: dto.vatDetails,
        totalTaxBase: dto.totalTaxBase,
        grossAmount: dto.grossAmount,
        currency: dto.currency,
        originalInvoice: dto.originalInvoice ?? null,
        billingVerificationSystem: dto.billingVerificationSystem,
        preauthAdjustment: dto.preauthAdjustment ?? null,
    };
}
function mapToDomainCustomer(customerDTO) {
    if (customerDTO === null)
        return null;
    return {
        name: customerDTO.name,
        address: customerDTO.address,
        taxId: customerDTO.taxId,
        phone: customerDTO.phone,
        email: customerDTO.email,
    };
}
